export const RESOURCE_USER_DETAILS_ACTION = {
  SET_SNACKBAR_MESSAGE: 'SET_SNACKBAR_MESSAGE',
  GLOBAL_NUDGES_UPDATE_CALLBACK: 'GLOBAL_NUDGES_UPDATE_CALLBACK'
};
